<script>

import {mapActions} from "pinia";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import {CreatorType} from "@/store/model/ImgLabel";

export default {
  name: "ProfileCriticalEvents",
  props: {
    entityId: {
      type: Number
    },
    entityType: {
      type: String
    }
  },
  computed: {
    frameUrl() {
      if (this.entityType === CreatorType.USER) {
        return `/user/${this.entityId}/mydesktop?tab=events&_f=true&showAsPage=false`
      } else if (this.entityType === CreatorType.ORGANIZATION) {
        return `/orgdesktop/${this.entityId}/events?_f=true&showAsPage=false`
      }
      throw new Error("Unexpected entity type: " + this.entityType);
    }
  },
  methods: {
    ...mapActions(baseLoaderStore, [
      'hideBaseLoader'
    ]),
  },
  mounted() {
    document.getElementById('criticalEventsViewFrame').onload = () => {
      this.hideBaseLoader();
    };
  }
}

</script>

<template>
  <div>
    <iframe :src="frameUrl" frameborder="0" id="criticalEventsViewFrame" class="critical-events-view-frame"></iframe>
  </div>
</template>

<style lang="scss">

.critical-events-view-frame {
  width: 100%;
  height: 1240px;
}

</style>